import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class AuthenticationService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  logIn = async (userEmail, userPassword) => {
    try {
      return await this.HttpService.loginPostJson(
        this.constants.loginServicesURLs.login,
        {
          userEmail: userEmail,
          userPassword: userPassword
        }
      );
    } catch (e) {
      throw e;
    }
  };
  logout = async session_id => {
    try {
      return await this.HttpService.postJson(
        this.constants.logoutServicesURLs.logout,
        {
          sessionId: session_id
        },
        session_id
      );
    } catch (e) {
      // throw e;
    }
  };

  verifyMFA = async (user_id,code) => {
    try {
      return await this.HttpService.verifyMFA(
        this.constants.loginServicesURLs.verifyMFA,
        {
          userId: user_id,
          code:code
        },
        null
      );
    } catch (e) {
      // throw e;
      throw e;

    }
  };



  
}
